import React, { Fragment, useContext, useCallback } from "react";
import ProductCategoryDropdown from "./ProductCategoryDropdown";
import { HomeContext } from "./index";
import clsx from "clsx";

const NavButton = ({ children, isActive, onClick, ariaLabel, ariaControls }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={ariaLabel}
    aria-expanded={isActive}
    aria-controls={ariaControls}
    className={clsx(
      "flex items-center justify-between w-full sm:w-auto",
      "px-4 py-3 sm:py-2.5 rounded-lg",
      "text-base sm:text-sm font-medium tracking-wide",
      "transition-all duration-200 ease-in-out",
      "hover:bg-emerald-50 active:bg-emerald-100",
      "focus:outline-none focus:ring-2 focus:ring-emerald-500",
      isActive
        ? "text-emerald-700 bg-emerald-50 ring-1 ring-emerald-200"
        : "text-gray-700 hover:text-emerald-700"
    )}
  >
    {children}
  </button>
);

const DropdownIcon = ({ isOpen }) => (
  <svg
    className={clsx(
      "w-5 h-5 sm:w-4 sm:h-4 transform transition-transform duration-200",
      isOpen ? "rotate-180" : "rotate-0"
    )}
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19 9l-7 7-7-7"
    />
  </svg>
);

const ProductCategory = () => {
  const { data, dispatch } = useContext(HomeContext);

  const toggleDropdown = useCallback(
    (type) => dispatch({ type, payload: !data[type] }),
    [data, dispatch]
  );

  return (
    <Fragment>
      <div className="bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Mobile-optimized layout */}
          <div className="flex flex-col gap-3 py-3 sm:py-4">
            {/* Categories Section */}
            <NavButton
              isActive={data.categoryListDropdown}
              onClick={() => toggleDropdown("categoryListDropdown")}
              ariaLabel="Toggle category list"
              ariaControls="category-list-dropdown"
            >
              <span>Categorias</span>
              <DropdownIcon isOpen={data.categoryListDropdown} />
            </NavButton>

            {/* Control Group */}
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 sm:border-l sm:border-gray-200 sm:pl-4">
              <NavButton
                isActive={data.filterListDropdown}
                onClick={() => toggleDropdown("filterListDropdown")}
                ariaLabel="Toggle filters"
                ariaControls="filter-list-dropdown"
              >
                <span>Filtrar</span>
              </NavButton>

              <NavButton
                isActive={data.searchDropdown}
                onClick={() => toggleDropdown("searchDropdown")}
                ariaLabel="Toggle search"
                ariaControls="search-dropdown"
              >
                <span>Pesquisa</span>
              </NavButton>
            </div>
          </div>
        </div>
      </div>

      <ProductCategoryDropdown />
    </Fragment>
  );
};

export default ProductCategory;